import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { CheckCircleIcon } from "components/CheckCircleIcon";
import { ModalWrapper } from "components/modalWrapper";

export interface MultibenefitsModalProps {
  open: boolean;
  onClose: () => void;
}

export const MultibenefitsModal = (props: MultibenefitsModalProps) => {
  const fixedCategories = ['Auxílio Alimentação', 'Refeição', 'Alimentação'];

  const flexibleCategories = ['Auxílio home-office', 'Mobilidade', 'Saúde', 'Educação', 'Cultura', 'Saldo Multi'];

  return (
    <ModalWrapper
      title="Benefícios na Caju"
      subtitle="A melhor forma de oferecer benefícios aos seus colaboradores através de um único cartão bandeira Visa."
      open={props.open}
      handleClose={props.onClose}
    >
      <Grid container spacing={1} columns={{ xs: 1, md: 2 }}>
        <Grid item xs={1}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderRadius: '20px',
              height: "100%",
            }}
          >
            <Typography variant="subtitle2" color="dark.dark" marginBottom={1}>
              Categorias fixas:
            </Typography>
            <Typography variant="body2">
              Exclusivo para alimentação do trabalhador, conforme a Lei
              14.442/2022
            </Typography>
            <List sx={{ pt: 2 }}>
              {fixedCategories.map((category) => (
                <ListItem key={category} sx={{ py: '6px' }}>
                  <ListItemIcon>
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary={category} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={1}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderRadius: '20px',
              height: "100%",
            }}
          >
          <Typography variant="subtitle2" color="dark.dark" marginBottom={1}>
            Categorias flexíveis:
          </Typography>
          <Typography variant="body2">
            O colaborador pode transferir o saldo entre as categorias.
          </Typography>
            <List sx={{ pt: 2 }}>
              {flexibleCategories.map((category) => (
                <ListItem key={category} sx={{ py: '6px' }}>
                  <ListItemIcon>
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary={category} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </ModalWrapper>
  );
};
